package org.catharsis.spendtel.core.impl

import dev.gitlive.firebase.auth.FirebaseAuth
import org.catharsis.spendtel.core.api.AuthTokenProvider

class FirebaseAuthTokenProvider(
    private val firebaseAuth: FirebaseAuth,
) : AuthTokenProvider {
    override suspend fun getIdToken(forceRefresh: Boolean): String {
        val user = firebaseAuth.currentUser
            ?: throw IllegalStateException("You must be signed in to call the SpendTel API.")
        return user.getIdToken(forceRefresh)
            ?: throw IllegalStateException("Could not retrieve a Firebase ID token.")
    }
}
